<template>
  <a
    class="share-button twitter-share-button"
    :href="shareUrl"
    target="_blank"
    @click="firePropTrackAction()"
  >
    <img src="@/assets/images/share-twitter.svg" />
    <span>Twitter</span>
  </a>
</template>

<script>
export default {
  computed: {
    shareUrl() {
      const url = encodeURIComponent("https://topjobs.xing.com/");
      return `https://twitter.com/intent/tweet?url=${url}`;
    },
  },
  methods: {
    firePropTrackAction() {
      const trackingParams = {
        PropTrackAction: "jobs_topjobs_social_share",
        PropActionOrigin: "jobs_topjobs_social_share_twitter",
      };
      window.ttt.event("PropTrackAction", trackingParams);
      console.log("propTrackAction", trackingParams);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/share-button.scss";
</style>
